import React from 'react';
import renderHTML from 'react-render-html';

const Required = ({ isRequired }) => (isRequired ? (<span className="required">*</span>) : (null));

const parseLabel = (text) => {
  if (!text) { return null; }
  return renderHTML(text);
};

export default ({ required, label, children, klassName }) => {
  if (!label) {
    return null;
  }
  return (
    <label className={`form-label ${klassName}`}>
      {parseLabel(label)} <Required isRequired={required} /> {children}
    </label>
  );
}
